/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type ContractsByCompanyIdQueryVariables = Exact<{
  companyId: string;
}>;


export type ContractsByCompanyIdQuery = { contract: Array<{ id: string, channel_url: string | null, buying_company: { id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, photos: Array<{ photo: { path: string, domain: string | null } }> }, supplying_company: { id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, photos: Array<{ photo: { path: string, domain: string | null } }> } }> };


export const ContractsByCompanyIdDocument = /*#__PURE__*/ gql`
    query contractsByCompanyId($companyId: uuid!) {
  contract(
    where: {_or: [{buyingCompanyId: {_eq: $companyId}}, {supplyingCompanyId: {_eq: $companyId}}]}
  ) {
    id
    channel_url
    buying_company {
      ...companyFragment
    }
    supplying_company {
      ...companyFragment
    }
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useContractsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useContractsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useContractsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables> & ({ variables: ContractsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>(ContractsByCompanyIdDocument, options);
      }
export function useContractsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>(ContractsByCompanyIdDocument, options);
        }
// @ts-ignore
export function useContractsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>;
export function useContractsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<ContractsByCompanyIdQuery | undefined, ContractsByCompanyIdQueryVariables>;
export function useContractsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>(ContractsByCompanyIdDocument, options);
        }
export type ContractsByCompanyIdQueryHookResult = ReturnType<typeof useContractsByCompanyIdQuery>;
export type ContractsByCompanyIdLazyQueryHookResult = ReturnType<typeof useContractsByCompanyIdLazyQuery>;
export type ContractsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useContractsByCompanyIdSuspenseQuery>;
export type ContractsByCompanyIdQueryResult = Apollo.QueryResult<ContractsByCompanyIdQuery, ContractsByCompanyIdQueryVariables>;